import BlockIcon from '@mui/icons-material/Block'
import React, { ReactNode } from 'react'
import { Link } from 'react-router-dom'
import './index.css'

const BoxMobileComponent = ({
  label,
  name,
  tagline,
  bgColor = '#F9FAFB', // Default to a neutral gray hex code
  icon,
  iconColor = '#4B5563', // Default to a gray hex code
  className = '',
  data_testid,
  to,
  disabled = false,
}: {
  label?: string
  name: string
  tagline: string
  bgColor?: string
  icon?: ReactNode
  iconColor: string
  className?: string
  data_testid?: string
  to?: string
  disabled?: boolean
}) => {
  const content = (
    <div
      className={`
        grid grid-rows-[auto_1fr_auto] items-start p-5 rounded-2xl w-full h-full relative 
        transition-all duration-200 ease-in-out
        ${
          disabled
            ? 'cursor-not-allowed bg-gray-100 border border-gray-200'
            : 'shadow-md hover:shadow-lg hover:scale-[1.02]'
        }
        ${className}
      `}
      style={!disabled ? { backgroundColor: bgColor } : {}}
      data-testid={data_testid}
    >
      {/* Top section for icon and label */}
      <div className='flex justify-between items-start w-full mb-4'>
        {icon && (
          <div className='flex p-3 items-center rounded-full bg-white shadow-sm'>
            {icon && React.isValidElement(icon)
              ? React.cloneElement(icon, {
                  // Preserve other icon props and override color
                  ...icon.props,
                  color: iconColor,
                })
              : icon}
          </div>
        )}
        {label && !disabled && (
          <div className='absolute top-4 right-4 text-xs font-bold px-2.5 py-1 rounded-full bg-white/70 backdrop-blur-sm border'>
            {label}
          </div>
        )}
        {disabled && (
          <div className='absolute top-4 right-4'>
            <BlockIcon sx={{ color: iconColor }} />
          </div>
        )}
      </div>

      {/* Text content area */}
      {/* mt-auto pushes this block to the bottom, ensuring headers align */}
      <div className='flex flex-col items-start gap-0.5 self-stretch'>
        <div className={`${disabled ? 'text-gray-600' : 'text-gray-900'} text-lg font-bold leading-tight`}>{name}</div>
        <div className={`text-gray-600 text-sm font-normal`}>{tagline}</div>
      </div>
    </div>
  )

  if (to && !disabled) {
    return (
      <Link to={to} className='flex-1 self-stretch'>
        {content}
      </Link>
    )
  }

  return <div className='flex-1 self-stretch'>{content}</div>
}

export default BoxMobileComponent
